import React, { useEffect, useState } from "react"
import { Button, Form, Modal, notification, Row } from "antd"
import { CloseOutlined, DownloadOutlined, PlusOutlined } from "@ant-design/icons"
import { useSelector } from "react-redux"
import Upload from "antd/lib/upload"
import axios from "axios"
import { selectCredentials } from "../../../app/applicationSlice"
import {
  AXIOS_IP,
  beforeUploadExcel,
  beforeUploadFileAndImage,
  customRequest,
} from "../fileUploadService"
import { PreviewImgOrPdf } from "../Preview"


//报备附件下载模板（固定阿里云OSS地址，不走接口）
const ATTACHMENT_TEMPLATE_URL =
  "https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/beian/%E4%B8%89%E5%9B%9B%E7%BA%A7%E6%89%8B%E6%9C%AF%E5%A4%87%E6%A1%88%E6%A8%A1%E6%9D%BF.xlsx"

export const SSJSSBatchFormModal = (props: {
  visible: boolean
  token: string
  onOk: () => void
  onCancel: () => void
}) => {
  const credentials: any = useSelector(selectCredentials)

  const [form] = Form.useForm()

  //报备表
  const [reportFileUrl, setReportFileUrl] = useState<any[]>([])

  //报备附件
  const [attachmentFileUrl, setAttachmentFileUrl] = useState<any[]>([])

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [confirmLoading, setConfirmLoading] = useState(false)

  useEffect(() => {
    form.setFieldsValue({
      reportFile: reportFileUrl,
      attachmentFile: attachmentFileUrl,
    })
  }, [reportFileUrl, attachmentFileUrl])

  useEffect(() => {
    if (!props.visible) {
      setReportFileUrl([])
      setAttachmentFileUrl([])
      form.resetFields()
    }
  }, [props.visible])

  const makeCustomRequest =
    (setter: React.Dispatch<React.SetStateAction<any[]>>) => (options: any) => {
      customRequest(options, AXIOS_IP, (data: any) => {
        const newurl = {
          fileConfigId: data?.configId,
          fileName: data?.name,
          fileType: data?.type,
          filePath: data?.path,
        }
        setter((prev) => [...prev, newurl])
      })
    }

  const handleRemove = (
    setter: React.Dispatch<React.SetStateAction<any[]>>,
    list: any[],
    index: number
  ) => {
    setter(list?.filter((v: any, i: number) => i !== index))
  }

  const renderFileList = (
    list: any[],
    setter: React.Dispatch<React.SetStateAction<any[]>>
  ) =>
    list?.map((v: any, index: number) => {
      return (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: 10,
          }}
        >
          <span style={{ paddingRight: 10 }}>
            {v.fileName}{" "}
            <a style={{ paddingLeft: 10 }} onClick={() => setPreviewFile(v)}>
              查看
            </a>
          </span>
          <CloseOutlined
            style={{
              position: "relative",
              top: 2,
              color: "rgb(161 161 161)",
            }}
            onClick={() => handleRemove(setter, list, index)}
          />
        </div>
      )
    })

  //下载报备附件模板（固定OSS地址，直接下载，不走接口）
  const downloadAttachmentTemplate = () => {
    const link = document.createElement("a")
    link.href = ATTACHMENT_TEMPLATE_URL
    link.download = "三四级手术备案模板.xlsx"
    link.target = "_blank"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleSubmit = () => {
    form.validateFields().then(() => {
      setConfirmLoading(true)
      const params = {
        applicantUserId: credentials?.userId,
        applicantUserName: credentials?.userName,
        applyPhone: credentials?.phone,
        reportFile: reportFileUrl,
        batchReportFiles: attachmentFileUrl,
        batchReport:1
      }
      axios({
        url: `${AXIOS_IP}/reviewSurgicalDirectoryRecord/saveOrUpdate`,
        headers: {
          "Content-Type": "application/json",
          "His-Auth": props.token,
        },
        withCredentials: false,
        method: "POST",
        data: params,
      })
        .then((res) => {
          if (res.data?.data || res.data?.success) {
            notification.success({
              message: "操作成功",
            })
            props.onOk()
          } else {
            notification.error({
              message: res.data?.msg || "操作失败，请稍后重试",
            })
          }
        })
        .catch(() => {
          notification.error({
            message: "请求异常，请稍后重试",
          })
        })
        .finally(() => {
          setConfirmLoading(false)
        })
    })
  }

  return (
    <>
      <Modal
        title="三四级手术目录批量报备"
        width={800}
        visible={props?.visible}
        onCancel={() => props?.onCancel()}
        onOk={handleSubmit}
        okText="提交"
        confirmLoading={confirmLoading}
        centered
        maskClosable={false}
      >
        <Form
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          style={{ paddingRight: 10 }}
        >
          <Form.Item
            label="报备附件（电子表格）"
            name="attachmentFile"
            rules={[{ required: true, message: "请上传报备附件" }]}
          >
            <Row align="middle">
              <Upload
                customRequest={makeCustomRequest(setAttachmentFileUrl)}
                beforeUpload={(file) =>
                  beforeUploadExcel(file, attachmentFileUrl, 1)
                }
                showUploadList={false}
                maxCount={1}
                accept={".xls,.xlsx"}
              >
                <Button icon={<PlusOutlined />}>上传报备附件</Button>
              </Upload>
              <Button
                type="link"
                icon={<DownloadOutlined />}
                onClick={downloadAttachmentTemplate}
              >
                下载模板
              </Button>

              {renderFileList(attachmentFileUrl, setAttachmentFileUrl)}
            </Row>
          </Form.Item>

          <Form.Item
            label="报备表（打印并盖章）"
            name="reportFile"
            rules={[{ required: true, message: "请上传报备表" }]}
          >
            <Row align="middle">
              <Upload
                customRequest={makeCustomRequest(setReportFileUrl)}
                beforeUpload={(file) =>
                  beforeUploadFileAndImage(file, reportFileUrl)
                }
                showUploadList={false}
                maxCount={1}
                accept={".pdf,.jpg,.jpeg,.png,.gif"}
              >
                <Button icon={<PlusOutlined />}>上传</Button>
              </Upload>

              {renderFileList(reportFileUrl, setReportFileUrl)}
            </Row>
          </Form.Item>


        </Form>
        <p style={{ padding: "0 10px 0 15px" }}>
          1.先下载报备附件模板，填写报备的手术目录后，打印原件并盖章。
        </p>

        <p style={{ padding: "0 10px 0 15px" }}>
          2.上传报备附件电子原件到【报备附件】。
        </p>

        <p style={{ padding: "0 10px 0 15px" }}>
          3.盖章后的打印件拍照并上传到【报备表】。
        </p>

        <p style={{ padding: "0 10px 0 15px" }}>
          4.上传完毕后，点击提交。
        </p>




      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
